/**
 * State interfaces and initial state for Assistant Runtime
 */

import type { ThreadMessage } from '@/types/messages';

export interface AssistantState {
  messages: ThreadMessage[];
  isLoading: boolean;
  error: string | null;
  currentThreadId: string | null;
  availableIds: Set<string>;
}

export const initialAssistantState: AssistantState = {
  messages: [],
  isLoading: false,
  error: null,
  currentThreadId: null,
  availableIds: new Set(),
};